<template>
  <div>
    <v-layout row>
    <!-- <v-container fluid>
      <v-card class="mx-auto" max-width="344" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">DANGEROUS</div>
            <v-list-item-title class="headline mb-1">SkillsRating</v-list-item-title>
            <v-list-item-subtitle>Delete or Update all peopleRatedAt data nodes.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-btn @click="updateSkills()" outlined class="primary--text filter-item">UPDATE</v-btn>
          <v-btn @click="deleteSkills()" outlined class="primary--text filter-item">DELETE</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-container fluid>
      <v-card class="mx-auto" max-width="344" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">DANGEROUS</div>
            <v-list-item-title class="headline mb-1">Find People</v-list-item-title>
            <v-list-item-subtitle>Find people.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-btn @click="findPeople()" outlined class="primary--text filter-item">UPDATE</v-btn>
        </v-card-actions>
      </v-card>
    </v-container> -->
    </v-layout>
    <v-container fluid>
      <v-card class="mx-auto" max-width="344" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">DANGEROUS</div>
            <v-list-item-title class="headline mb-1">Find Missing Tech Props</v-list-item-title>
            <v-list-item-subtitle>Find who is missing tech props and in which skill.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-btn @click="findMissingTech()" outlined class="primary--text filter-item">FIND</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

    <v-container fluid>
      <v-layout row>
        <v-flex xs12 sm10 offset-sm1>
          <v-alert color="info" icon="warning" dismissible v-model="isDuplicateEmail">
            <span
              style="color:red; font-size:1.3em"
            >Woah, slow down there, Slappy. That email is already in the list.</span>
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex sm2 offset-sm1 md2 lg1>
          <v-btn color="green" @click="addAdministrator(administratorsRef);" fab small>
            <v-icon class="white--text">add</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs8 lg9>
          <v-text-field label="E-mail" v-model="email" :rules="[rules.required, rules.email]"></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout row>
      <v-flex xs12 sm10 offset-sm1>
        <v-card>
          <v-toolbar class="primary white--text">
            <v-toolbar-title>Administrators</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-list>
            <v-list-item
              avatar
              v-for="administrator in administrators"
              v-bind:key="administrator['.key']"
            >
              <v-list-item-content>
                <v-list-item-title v-text="administrator.email"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-avatar>
                <v-dialog v-model="deleteDialog" persistent>
                  <v-btn
                    color="error"
                    @click="setAdministratorKey(administrator['.key']); "
                    fab
                    small
                    slot="activator"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <v-card>
                    <v-card-title class="headline">Remove Administrator?</v-card-title>
                    <v-card-text>Are you sure you want to remove {{ selectedAdministrator.email }} from the list of Administrators?</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
                      <v-btn
                        color="darken-1"
                        flat
                        @click="removeAdministrator(selectedAdministrator.key);  deleteDialog = false"
                      >Remove</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-list-item-avatar>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { setAdministrator } from "@/vue-service-auth";
import {
  findPeopleToLog,
  erasePeopleRatedAt,
  fillPeopleRatedAt,
  findMissingTechProperties
} from "@/vue-service-utility";
import { peopleRef, administratorsRef } from "@/vue-service-database";
import {} from "@/vue-service-skills";

export default {
  data() {
    return {
      administratorsRef,
      email: "email@jahnelgroup.com",
      rules: {
        // validate the email format
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      deleteDialog: false,
      isDuplicateEmail: false,
      selectedAdministrator: {
        key: "",
        email: "",
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    administrator() {
      return this.$store.getters.administrator;
    },
  },
  firebase: {
    people: peopleRef,
    administrators: administratorsRef,
  },
  methods: {
    addPerson() {
      peopleRef.push({ email: this.email, edit: false });
    },
    addAdministrator(ref) {
      this.isDuplicateEmail = this.administrators
        .map((a) => a.email)
        .includes(this.email);

      if (!this.isDuplicateEmail) {
        ref.push({ email: this.email, edit: false });
      }
    },
    removePerson(key) {
      peopleRef.child(key).remove();
    },
    removeAdministrator(key) {
      administratorsRef.child(key).remove();
    },
    setAdministratorKey(key) {
      this.selectedAdministrator.key = key;
      console.log(
        "selectedAdministrator.key: ",
        this.selectedAdministrator.key
      );
    },
    setAdministratorEmail(email) {
      this.selectedAdministrator.email = email;
      console.log(
        "selectedAdministrator.email: ",
        this.selectedAdministrator.email
      );
    },
    eraseSkills() {
      console.log("Erase PeopleRatedAt Feature Not Enablbled");
      // erasePeopleRatedAt();
    },
    updateSkills() {
      console.log("Update PeopleRatedAt Feature Not Enablbled");
      fillPeopleRatedAt();
    },
    findPeople() {
      console.log("Ding");
      findPeopleToLog();
    },
    findMissingTech() {
      console.log("techprops Go!");
      findMissingTechProperties();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Roles/Roles.vue